class ProductMarketplaceStockLevels{
    constructor({lastInStock, inStockPercentages, estimatedDaysOfCover}){
        this.lastInStock = lastInStock;
        this.inStockPercentages = inStockPercentages;
        this.estimatedDaysOfCover = estimatedDaysOfCover;
    }
}

export { ProductMarketplaceStockLevels };